var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlusCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Zm17.191-3.621a1.111 1.111 0 0 0-1.493-1.646c-1.477 1.34-2.586 2.543-3.523 4.005-.682 1.065-1.256 2.24-1.818 3.666l-2.004-2.066a1.111 1.111 0 0 0-1.595 1.547l3.232 3.333a1.11 1.11 0 0 0 1.847-.408c.747-2.146 1.41-3.626 2.21-4.873.794-1.24 1.752-2.296 3.144-3.558Z",
  fill: "#fff"
})));
export default SvgPlusCheck;